export class TemplateConstant {
    constructor() {
        this.fullScreenSliderTemplateId = 0;
        this.navbarTemplateId = 0;
        this.googleMapZoom = 15;
        this.hasNoParallax = true;
    }
}
